import React, { ComponentProps } from 'react';

export default function HyperIcon(props: ComponentProps<"svg">) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" {...props}>
      <circle cx="15" cy="15" r="15" fill="white"/>
      <path d="M12.6667 9.02631H8V13.8403H12.6667V9.02631Z" fill="#6C53E8"/>
      <path d="M12.6667 18.6543H8V23.4683H12.6667V18.6543Z" fill="#6C53E8"/>
      <path d="M12.6641 13.8407V18.6547H17.3307V23.4687H21.9974V18.6547V13.8407H17.3307H12.6641Z" fill="#6C53E8"/>
    </svg>
  );
}
